import hmd_softlock_logo from 'url:/assets/hmd_softlock_logo.svg'
import React from 'react'
import { INPUT_FORM_COMMON_SIZE } from '../../genericComponents/OverlayWrapper'
import { FlexContainer } from '../../genericComponents/layout/FlexContainer'
import { AuthPageContainer } from '../../genericComponents/layout/AuthPageContainer'

export const PasswordChangedPage: React.FC = () => {
  return (
    <AuthPageContainer>
      <FlexContainer
        align="items-center"
        justify="justify-center"
        className={'flex-col ' + INPUT_FORM_COMMON_SIZE}
      >
        <img src={hmd_softlock_logo} alt="" className="mb-6 w-40" />
        <h2 className="text-base font-semibold self-center my-5">Password changed</h2>
        <p className="self-center">
          You have successfully updated your password. Use your new password to sign in.
        </p>
        <a
          className="text-linkColor cursor-pointer no-underline flex justify-center mt-8"
          href="/logout"
        >
          Return to Sign in
        </a>
      </FlexContainer>
    </AuthPageContainer>
  )
}
